import { EuiLoadingSpinner, EuiText } from "@elastic/eui"
import { useEffect, useState } from "react";

export const DetalleContent = (props:any) =>{

    const {item, onDetalleFilter} = props;

    const [detalle, setDetalle] = useState<any>(undefined)

    const getData = async() =>{
        await onDetalleFilter && onDetalleFilter(item).then((value:any) => {setDetalle(value)})
    }

    const getColorText = (estado:number) =>{
        switch (estado) {
            case 0: return 'secondary';
            case 1: return 'danger';
            case 2: return 'warning';
            default: return 'default';
        }
    }

    const getColorMarket = (estado:number) =>{
        switch (estado) {
            case 0: return '';
            case 1: return 'error-state';
            case 2: return 'warning-state';
            default: return '';
        }
    }

    const getDetalles = ()=>{
        return detalle.map((d:any,i:number)=>{
            return (<>
            <li className={`market ${getColorMarket(d.idTipoError)}`}><EuiText key={d.idImportacion} size={'s'} color={getColorText(d.idTipoError)}>{d.descripcion}</EuiText></li>
            {detalle[i+1] && <hr className={`hr ${getColorMarket(d.idTipoError)}`}/>}
           </>) 
        })
    }

    useEffect(()=> {
       getData();
    },[])

    
    return detalle ? <ul className='lista-detalle-log'>{getDetalles()}</ul> :  <EuiLoadingSpinner size="m" />
}